module.exports = __webpack_public_path__ + "static/media/chart-bitcoin.69b6d279.jpg";